import { OdataManager } from '@/api/odata/odata-manager';
import { PackageKS2StatusHistory } from '@/api/model/interfaces';

export default class PackageKS2StatusHistoryOdata extends OdataManager<PackageKS2StatusHistory> {}
